"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PrimaryCallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="primary-call-to-action" ref={ref} className="w-full bg-dark-background py-16 md:py-20">
      <div className={`
          mx-auto max-w-4xl px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}
        `}>
        <p className="mb-8 text-lg text-foreground-dark md:text-xl font-sans leading-relaxed">
          Experience unparalleled transparency with verified land titles, live site monitoring, and GPS-stamped progress logs.
        </p>
        <Link to="/DataRoomPage">
          <Button size="lg" className="bg-primary text-foreground-primary font-semibold px-8 py-4 rounded-md shadow-medium hover:bg-primary-hover transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:shadow-strong hover:-translate-y-0.5 active:translate-y-0 focus-visible:ring-2 focus-visible:ring-ring border-b-2 border-transparent hover:border-accent">
            Access the Data Room
          </Button>
        </Link>
      </div>
    </section>;
}